export const MAX_WORKOUT_TITLE_LENGTH = 100;
export const MAX_WORKOUT_DESCRIPTION_LENGTH = 2000;

export const MAX_ROUTINE_TITLE_LENGTH = 100;

export const MAX_PINNED_NOTE_LENGTH = 10000;

export const MAX_EXERCISE_TITLE_LENGTH = 100;

export const MAX_COMMENT_LENGTH = 250;

export const MAX_PROFILE_FULL_NAME_LENGTH = 100;
export const MAX_PROFILE_DESCRIPTION_LENGTH = 200;
export const MAX_PROFILE_WEBSITE_LENGTH = 100;

export const MIN_PROFILE_PREVIEW_WORKOUTS = 10;

export const HAS_ENABLED_CONTACTS_SYNC_KEY = 'HasEnabledContactsSync';

export const MAX_IMPORTED_EXERCISE_TEMPLATES = 300;
export const MAX_IMPORTED_WORKOUTS = 3000;
